<template>
	<Row class="flex-align-center flex-justify-space-between width-100">
		<NotificationIconsBar :selectedIcon="selectedIcon" @choose-mdi-icon="onChooseIcon" :icons="icons" />
		<NotificationIconColorPicker :colors="colors" v-model="activeColor" />
	</Row>
</template>
<script>
import { cloneDeep } from 'lodash';
import { appURL } from '@/store/modules/main/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import NotificationIconsBar from '@/components/BlockEditorNotification/CustomizeTabs/CustomizeNotificationMdiIcon/NotificationIconsBar.vue';
import NotificationIconColorPicker from '@/components/BlockEditorNotification/CustomizeTabs/CustomizeNotificationMdiIcon/NotificationIconColorPicker.vue';

const FILE_NAME_COLOR_DELIMITER = ' _ ';

export default {
	name: 'CustomizeNotificationMdiIcon',
	components: {
		NotificationIconsBar,
		NotificationIconColorPicker,
	},
	props: {
		selectedEntityId: { type: String },
	},
	computed: {
		...mapGettersShorthand({ appURL }),
		icons() {
			return this.iconsByColor[this.activeColor] || [];
		},
		colors() {
			return Object.keys(this.iconsByColor) || [];
		},
	},
	methods: {
		onChooseIcon(iconName) {
			this.selectedIcon = iconName;
			const icon = this.icons.find((icon) => icon.name === iconName);
			this.$emit('change-icon', { icon: icon.url, entity_id: icon.name });
		},
		getIconUrl(iconName, iconColor) {
			return `${this.appURL}notificationIcons/${iconColor}/${iconName}.png`.replaceAll(' ', '%20');
		},
		initializeIcons() {
			const requireComponents = require.context('../../../../public/notificationIcons/', true);
			requireComponents.keys().forEach((key) => {
				const cleanKey = key.replace('./', '').replace('.png', '');
				const colorAndNameArr = cleanKey.split('/');
				const color = colorAndNameArr[0];
				const name = colorAndNameArr[1];
				const allColorIcons = cloneDeep(this.iconsByColor[color] || []);
				allColorIcons.push({ name, url: this.getIconUrl(name, color) });
				this.iconsByColor[color] = allColorIcons;
			});
		},
	},
	created() {
		this.initializeIcons();
		if (this.selectedEntityId) {
			this.selectedIcon = this.selectedEntityId;
			this.activeColor = this.selectedEntityId.split(FILE_NAME_COLOR_DELIMITER)[1];
		} else {
			this.activeColor = this.colors[0];
			this.selectedIcon = this.icons[0].name;
		}
	},
	data() {
		return {
			iconsByColor: {},
			searchString: '',
			activeColor: null,
			selectedIcon: null,
		};
	},
	watch: {
		activeColor: {
			handler(newV, oldV) {
				if (newV && oldV && this.selectedIcon) {
					this.onChooseIcon(this.selectedIcon.replace(oldV, newV));
				}
			},
		},
	},
};
</script>
<style scoped lang="scss"></style>
